module.exports = __webpack_public_path__ + "static/egypt.8b4f7a6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/egypt.jpg
// module id = 462
// module chunks = 179856512599499